import { render, staticRenderFns } from "./ModuleBalanceLoader.vue?vue&type=template&id=2a04486e"
var script = {}
import style0 from "./ModuleBalanceLoader.vue?vue&type=style&index=0&id=2a04486e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports